import React from "react";
import GeneralUsers from "./UserDetails/GeneralUsers";

export default function UserDetails({ profile, profileType }) {
  return <GeneralUsers profile={profile} profileType={profileType}/>;
}
